// Utility to create URL-friendly slugs from Vietnamese text

export const slugify = (text) => {
  if (!text) return ''
  
  // Convert to lowercase
  let slug = text.toLowerCase()
  
  // Remove Vietnamese accents
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  
  // Replace special Vietnamese characters
  slug = slug.replace(/đ/g, 'd')
  slug = slug.replace(/Đ/g, 'D')
  
  // Replace spaces with hyphens
  slug = slug.replace(/\s+/g, '-')
  
  // Remove special characters
  slug = slug.replace(/[^\w\-]+/g, '')
  
  // Remove multiple hyphens
  slug = slug.replace(/\-\-+/g, '-')
  
  // Trim hyphens from start and end
  slug = slug.replace(/^-+/, '').replace(/-+$/, '')
  
  return slug
}

// Generate unique slug by appending ID if needed
export const generateUniqueSlug = (text, id) => {
  const baseSlug = slugify(text)
  if (!id) return baseSlug
  
  // Take first 6 characters of ID for uniqueness
  const shortId = id.substring(0, 6)
  return `${baseSlug}-${shortId}`
}

export default slugify

